import React from 'react'
import Page from 'component/page-container'
import moment from 'moment'
import { nl2br } from 'helpers'
import { HashLink } from 'react-router-hash-link';
import 'moment/locale/ru'
import './style.css'

/* global API */

const DiscountListRoute = () => {
    const [discounts, setDiscounts] = React.useState([])
    React.useEffect(() => {
        API.instance().getDiscountList().then(discounts => setDiscounts(discounts))
    }, [])

    return (
        <Page className="discount-list-page" h1="Скидки">
            <div className="page__inner">
                <div className="container">
                    Скидки добавляет телеграм-бот <HashLink to="/bots#discounts_club_bot">Хранитель скидок</HashLink>.
            </div>
                <table className="discount-list">
                    <tbody>
                        {discounts.map(discount => (
                            <tr key={discount?.id} className="discount-list__discount">
                                <td
                                    className="discount-list__text"
                                    dangerouslySetInnerHTML={{ __html: nl2br(discount.text) }}
                                />
                                <td className="discount-list__date">
                                    {moment(discount.createdAt).format('ll')}
                                </td>
                                <td className="discount-list__user">
                                    {discount?.user?.name} {discount?.user?.surname}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </Page>
    )
}

export default DiscountListRoute
